export default [
	{//会员管理
		path: 'member_list',
		name: 'm_platform_user',
		component: () => import('@/pages/member/platform_user_list')
	}];